<template>

  <!-- Meeting add validation -->
  <validator name="validator">

    <form novalidate>
      <fieldset>

        <legend>Contact</legend>

        <!-- Contact -->
        <div class="form-group">
          <label for="contact">Participant *</label>
          <input
            id      = "contact"
            v-model = "data.contactId"
            class   = "form-control"
            type    = "hidden"
          >
          <br/>{{ contact.leader_lastname }} {{ contact.leader_firstname }}
        </div>

        <!-- Project -->
        <div class="form-group divproject">
          <label for="project">Parcours</label>
          <select
            id      = "project"
            v-model = "data.projectId"
            class   = "form-control"
          >
          <option value=""></option>
          <option v-for="project of projects" :value="project.id" >
            {{ project.name }} - {{ project.first_meeting_date }} | {{ project.exit_date }}
          </option>
          </select>
        </div>

        <!-- Phase -->
        <div class="form-group">
          <label for="phase">Phase</label>
              <select id="phase_id" name="phase_id" v-model="data.phaseId" class="form-control">
                <option value=""></option>
                <option v-for="phase in phases" :key="phase.id" v-bind:value="phase.id">{{ phase.name }}</option>
              </select>
        </div>

      </fieldset>

      <fieldset>

        <legend>Informations générales</legend>

        <!-- Title -->
        <div class="form-group">
          <label for="">Nom de l'événement</label>
          <input
            id               = "title"
            class            = "form-control"
            type             = "text"
            v-model          = "data.title"
          >
          <!-- <small class="form-text text-danger" v-if="$validator.title.required">Vous devez saisir un titre</small> -->
        </div>
        <div class="row form-group">
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.rdvindividuel" >Rendez-vous individuel</switch>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.rdvcollectif" >Rendez-vous collectif</switch>
            </div>
          </div>
        </div>
        <!-- User -->
        <!--
        <div class="form-group" >
          <label for="">Agenda de</label>
          <select
            id      = "user"
            class   = "form-control"
            v-model = "data.userId"
          >
          <option value=""></option>
          <option v-for="user of users" :value="user.id" :class="{ 'me': user.id == authenticatedUser.id }" >
            {{ user.firstname }} {{ user.lastname }}
          </option>
          </select>
        </div>
        -->

        <div class="form-inline">

          <!-- Day -->
          <label for="data_day">Le</label>
          <!--
          <date-picker :time.sync="data.day" :option="datepickerOptions" ></date-picker>
          -->
          <input
            id               = "data_day"
            class            = "form-control"
            type             = "text"
            v-model          = "data.day"
          >

          <!-- Start hour -->
          <label for="hour">de</label>
          <select
            id              = "startHour"
            class           = "form-control"
            v-model         = "data.startHour"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="hour in businessHours" :value="hour" >{{ hour }}</option>
          </select>

          <!-- Start minutes -->
          <select
            id              = "startMinutes"
            class           = "form-control"
            v-model         = "data.startMinutes"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="minutes in ['00', '15', '30', '45']" >{{ minutes }}</option>
          </select>
          <label for="">à</label>

          <!-- End hour -->
          <select
            id              = "endHour"
            class           = "form-control"
            v-model         = "data.endHour"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="hour in businessHours" :value="hour" >{{ hour }}</option>
          </select>

          <!-- End minutes -->
          <select
            id              = "endMinutes"
            class           = "form-control"
            v-model         = "data.endMinutes"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="minutes in ['00', '15', '30', '45']" >{{ minutes }}</option>
          </select>

          <label for="duration">Durée de l'événement</label>
          <input
            id               = "duration"
            class            = "form-control"
            type             = "text"
            v-model          = "data.duration"
            v-validate:duration = "validationRules.duration"
	  >

        </div>

        <div class="row form-group">
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.all_day" >Toute la journée</switch>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.recurring" >Rendez-vous récurrent</switch>
            </div>
          </div>
        </div>

        <!-- Lieu du rdv -->
        <div class="form-group">
          <label for="place">Lieu du rendez-vous</label>
              <select id="place_id" name="place_id" v-model="data.placeId" class="form-control">
                <option value=""></option>
                <option v-for="place in places" :key="place.id" v-bind:value="place.id">{{ place.name }}</option>
              </select>
        </div>

      </fieldset>

      <fieldset>

        <legend>Intervenants</legend>

        <!-- Intervenant1 -->
        <div class="form-group">
          <label for="firstintervenant">Agenda de / Intervenant 1 *</label>
              <select id="firstintervenant_id" name="firstintervenant_id" v-model="data.firstintervenantId" class="form-control" v-validate:firstintervenant_id = "validationRules.firstintervenant_id">
                  <option v-for="user of users" :value="user.id" :key="user.id" v-bind:value="user.id" :class="{ 'me': user.id == data.firstintervenantId }" :selected="user.id == data.firstintervenantId">
                    {{ user.firstname }} {{ user.lastname }}
                  </option>
                  <!-- <option v-for="firstintervenant in firstintervenants" :key="firstintervenant.id" v-bind:value="firstintervenant.id" :class="{ 'me': firstintervenant.id == data.firstintervenantId}" :selected="firstintervenant.id == data.firstintervenantId">{{ firstintervenant.firstname }} {{ firstintervenant.lastname }}</option> -->
              </select>
              <small class="form-text text-danger" v-if="$validator.firstintervenant_id.required">Vous devez choisir un intervenant</small>
        </div>

        <!-- Intervenant2 -->
        <div class="form-group">
          <label for="secondintervenant">Intervenant 2</label>
              <select id="secondintervenant_id" name="secondintervenant_id" v-model="data.secondintervenantId" class="form-control">
                  <option value=""></option>
                  <option v-for="firstintervenant in firstintervenants" :key="secondintervenant.id" v-bind:value="firstintervenant.id" :class="{ 'me': firstintervenant.id == data.secondintervenantId}" :selected="firstintervenant.id == data.secondintervenantId">{{ firstintervenant.firstname }} {{ firstintervenant.lastname }}</option>
              </select>
        </div>

        <!-- Intervenant3 -->
        <div class="form-group">
          <label for="thirdintervenant">Intervenant 3</label>
              <select id="thirdintervenant_id" name="thirdintervenant_id" v-model="data.thirdintervenantId" class="form-control">
                  <option value=""></option>
                  <option v-for="firstintervenant in firstintervenants" :key="thirdintervenant.id" v-bind:value="firstintervenant.id" :class="{ 'me': firstintervenant.id == data.thirdintervenantId}" :selected="firstintervenant.id == data.thirdintervenantId">{{ firstintervenant.firstname }} {{ firstintervenant.lastname }}</option>
              </select>
        </div>

        <!-- Intervenant extérieur -->
        <div class="form-group">
          <label for="">Intervenant extérieur</label>
          <input
            id               = "intervenantexterieur"
            class            = "form-control"
            type             = "text"
            v-model          = "data.intervenantexterieur"
          >
        </div>
      </fieldset>

      <fieldset>

        <legend>Description</legend>

        <!-- Description 
        <label for="">Description</label>
        <textarea
          id                     = "description"
          class                  = "form-control"
          rows                   = "8"
          v-model                = "data.description"
          v-validate:description = "validationRules.description"
        >
        </textarea>-->

        <!-- Présence -->
        <div class="form-group">
          <label for="presence">Présence</label>
              <select id="presence_id" name="presence_id" v-model="data.presenceId" class="form-control">
                  <option value=""></option>
                  <option v-for="presence in presences" :key="presence.id" v-bind:value="presence.id">{{ presence.name }}</option>
              </select>
        </div>

        <!-- Contenu -->
        <div class="form-group">
          <label for="content">Contenu</label>
              <select id="content_id" name="content_id" v-model="data.contentId" class="form-control">
                  <option value=""></option>
                  <option v-for="content in contents" :key="content.id" v-bind:value="content.id">{{ content.name }}</option>
              </select>
        </div>

        <!-- Formation -->
        <div class="form-group">
          <label for="training">Formation pratique</label>
              <select id="training_id" name="training_id" v-model="data.trainingId" class="form-control">
                  <option value=""></option>
                  <option v-for="training in trainings" :key="training.id" v-bind:value="training.id">{{ training.name }}</option>
              </select>
        </div>

        <!-- Synthèse -->
        <label for="">Synthèse</label>
        <textarea
          id                     = "synthese"
          class                  = "form-control"
          rows                   = "8"
          v-model                = "data.synthese"
        >
        </textarea>

        <!-- Observations 
        <label for="">Observations</label>
        <textarea
          id                     = "observations"
          class                  = "form-control"
          rows                   = "8"
          v-model                = "data.observations"
        >
        </textarea>-->

        <!-- Convention -->
        <div class="form-group">
          <label for="">Convention</label>
          <input
            id               = "convention"
            class            = "form-control"
            type             = "text"
            v-model          = "data.convention"
          >
        </div>

      </fieldset>

      <!-- Errors -->
      <div v-if="$validator.errors" >
        <hr>
        <ul>
          <li class="errors" v-for="error in $validator.errors" >{{ error.message }}</li>
        </ul>
      </div>

    </form>

  </validator>

</template>

<script>
  // Npm packages
  import DatePicker from 'vue-datepicker/vue-datepicker-1.vue'
  import { Switch } from 'mint-ui'

  // Options
  import { businessHours, datepickerOptions } from 'src/options/date'

  // jQuery
  // import $ from 'jquery'

  // getProjectsOfContact
  // import store from 'src/vuex/store'
  // import { getProjectsOfContact } from 'src/vuex/actions/contactActions'

  export default {
    props: [ 'data', 'validationRules', 'validation', 'phases', 'contents', 'trainings', 'presences', 'places', 'firstintervenants', 'users', 'contacts', 'projects', 'authenticated-user', 'contactId', 'projectId', 'contact' ],
    validators: {
      hourAfter (val) {
        // TODO move this out of component (validator)
        return Number(this.vm.data.startHour + this.vm.data.startMinutes) < Number(this.vm.data.endHour + this.vm.data.endMinutes)
      }
    },
    data () {
      return {
        businessHours,
        datepickerOptions
      }
    },
    methods: {
    },
    components: {
      DatePicker,
      Switch
    },
    ready () {
      // let paramtmp = this.$route.path.substring(5)
    }
  }
</script>

<style lang="scss" >
  .show { display : block }
  .hide { display : none !important }
</style>



// WEBPACK FOOTER //
// MeetingFormEdit.vue?67d419dc